import getClassCode from './get-class';
import setClassCode from './set-class';

import getCookieCode from './get-cookie';
import setCookieCode from './set-cookie';

import getFormValueCode from './get-form-value';
import setFormValueCode from './set-form-value';

export default {
    getClass: {
        label: 'Get CSS Class',
        code: getClassCode.replace(/^\n|\n$/g, ''),
    },

    getCookie: {
        label: 'Get Cookie',
        code: getCookieCode.replace(/^\n|\n$/g, ''),
    },

    getFormValue: {
        label: 'Get Form Value',
        code: getFormValueCode.replace(/^\n|\n$/g, ''),
    },

    setClass: {
        label: 'Set CSS Class',
        code: setClassCode.replace(/^\n|\n$/g, ''),
    },

    setCookie: {
        label: 'Set Cookie',
        code: setCookieCode.replace(/^\n|\n$/g, ''),
    },

    setFormValue: {
        label: 'Set Form Value',
        code: setFormValueCode.replace(/^\n|\n$/g, ''),
    },
};
